import { useRecordingEntitlement } from '@/entities/user/currentUser';

import { isOutOfRecordingMinutes } from '@/shared/lib/billing/recordingEntitlement';

export const useIsOutOfRecordingMinutes = (spaceId?: string): boolean =>
  isOutOfRecordingMinutes(useRecordingEntitlement(spaceId));
